// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "sou360-65b90.firebaseapp.com",
  "projectId": "sou360-65b90",
  "storageBucket": "sou360-65b90.firebasestorage.app",
  "messagingSenderId": "538213016764",
  "appId": "1:538213016764:web:7842fe73c7607997cc1cb9",
  "measurementId": "G-RWQSYB07T7",
  "apiKey": "AIzaSyD-xe_0SEfcmfCZxWgaVz--ACLm37hslqI"
};
